// Copyright (c) Docugami, Inc. All rights reserved.

import { ITooltipHostStyles, TooltipHost, TooltipOverflowMode } from "@fluentui/react";
import { primaryTheme } from "components/shell/presentation/AppStyles";
import { ReactNode } from "react";

const overflowTooltipStyles: ITooltipHostStyles = {
    root: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }
}

export interface OverflowTextProps {
    content: string | undefined;
    children?: ReactNode;
    tooltipOverflowMode?: TooltipOverflowMode;
}

export const OverflowTooltipText = (props: OverflowTextProps): JSX.Element => {
    return (
        <TooltipHost
            content={props.content}
            overflowMode={props.tooltipOverflowMode || TooltipOverflowMode.Parent}
            styles={overflowTooltipStyles}
            calloutProps={{ theme: primaryTheme }}>
            {props.children}
        </TooltipHost>
    )
}
